export default "__VITE_ASSET__PZr_rHKC__"